import React, { createContext, Dispatch, SetStateAction, useContext, useEffect, useRef, useState } from 'react'
import { StompService } from './StompService'

interface StompContextProps {
  stomp?: StompService
  connected: boolean
  setConnected?: Dispatch<SetStateAction<boolean>>
}

const StompContext = createContext<StompContextProps>({
  stomp: undefined,
  connected: true,
  setConnected: undefined
})

export const StompProvider = ({ children }: any) => {
  const stomp = useRef<StompService | undefined>(new StompService())
  const [connected, setConnected] = useState(true)

  useEffect(() => {
    const current = stomp.current

    return () => {
      if (current) current.cleanStomp()
    }
  }, [])

  return (
    <StompContext.Provider
      value={{
        stomp: stomp.current,
        connected,
        setConnected
      }}
    >
      {children}
    </StompContext.Provider>
  )
}

export const useStomp = () => useContext(StompContext)
